<app-document-countries
  [name]="'Условия страхования'"
  [countries]="countries"
></app-document-countries>
